import Link from "next/link";
import type { MDXFrontMatter } from "types";
import { Prose } from "components/atoms/Prose";
import { Tag } from "components/atoms/Tag";
import { formatDate } from "utils/formatDate";
import { SubTitle, Text } from "utils/styling/typography.styled";
import { slugify } from "utils/utils";
import { Article, BlogListContainer, DescriptionContainer, ListItem, TagsContainer, Time } from "./BlogList.styled";
interface BloglistProps {
  blogs: Array<MDXFrontMatter>;
}
export const BlogList: React.FC<BloglistProps> = ({
  blogs
}) => {
  return <BlogListContainer className="blog-list" data-sentry-element="BlogListContainer" data-sentry-component="BlogList" data-sentry-source-file="index.tsx">
            {blogs.map((blog, index) => <ListItem key={index}>
                    <Article>
                        <Time suppressHydrationWarning>
                            {formatDate(blog.date)}
                        </Time>
                        <SubTitle>
                            <Link title={blog.slug} href={`/blogs/${blog.slug}`}>
                                {blog.title}
                            </Link>
                        </SubTitle>
                        {blog.description && <DescriptionContainer>
                                <Prose>
                                    <Text>{blog.description}</Text>
                                </Prose>
                            </DescriptionContainer>}
                        {blog.tags && <TagsContainer>
                                {blog.tags.map((tag, index) => <li key={index}>
                                        <Tag href={`/blogs/tagged/${slugify(tag)}`}>
                                            {tag}
                                        </Tag>
                                    </li>)}
                            </TagsContainer>}
                    </Article>
                </ListItem>)}
        </BlogListContainer>;
};